import { useState } from 'react';

import { useAuth } from 'auth';
import { useSpring, animated, interpolate } from '@react-spring/web';

import { Flex, Layout } from 'antd';
import { FontAwesomeIcon } from '../../components';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { useHistory, useLocation } from 'react-router';

import './Header.sass';
import { ThemeToggle } from 'components/Layout/ThemeToggle';

export default function Header(props: any) {

	let history = useHistory();
	let location = useLocation();

	let hasSubHeader: Boolean =
		!location.pathname ||
		(location.pathname !== '/projects' &&
			location.pathname !== '/' &&
			location.pathname !== '' &&
			location.pathname !== '/profile');

	return (
		<Layout.Header style={{
			borderBottom: 'var(--ant-line-width) var(--ant-line-type) var(--ant-color-text-secondary)',
		}}>
			<div id="SubHeader-root" className="nowrap"></div>
		</Layout.Header>
	);
}
